import { Venue, CreateVenueRequest, UpdateVenueRequest, VenueFilters } from '../types/venue';
import api from './authService';

export const venueService = {
  async getAllVenues(filters?: VenueFilters): Promise<Venue[]> {
    const response = await api.get('/venues', {
      params: {
        search: filters?.search,
        isActive: filters?.isActive
      }
    });
    return response.data.data || response.data;
  },

  async getActiveVenues(): Promise<Venue[]> {
    const response = await api.get('/venues/active');
    return response.data.data || response.data;
  },

  async getVenueById(venueId: string): Promise<Venue> {
    const response = await api.get(`/venues/${venueId}`);
    return response.data.data || response.data;
  },

  async createVenue(venueData: CreateVenueRequest): Promise<Venue> {
    const response = await api.post('/venues', venueData);
    return response.data.data || response.data;
  },

  async updateVenue(venueId: string, venueData: UpdateVenueRequest): Promise<Venue> {
    const response = await api.put(`/venues/${venueId}`, venueData);
    return response.data.data || response.data;
  },

  async deleteVenue(venueId: string): Promise<void> {
    await api.delete(`/venues/${venueId}`);
  },

  /**
   * ════════════════════════════════════════════════════════════════════════════════════════
   * ITT VOLT EGY MÁSODIK, HÍVÓ NÉLKÜLI „szabad-e az asztal" ÚT — TÖRÖLVE [NB-g, 2026-09-14]
   * ════════════════════════════════════════════════════════════════════════════════════════
   * MI VOLT ITT: `checkVenueAvailability()` (a `GET /api/venues/{id}/availability` wrapperje),
   * hozzá `hasEnoughTables()` segédfüggvény, `VenueAvailabilityResponse` és
   * `VenueConflictingEvent` típusok, valamint 20 teszt
   * (`src/services/__tests__/tableAvailability.test.ts`).
   *
   * MIÉRT TÖRÖLTÜK — MÉRVE 2026-09-14:
   *  1. PRODUKCIÓS HÍVÓJA NEM VOLT, sem a weben, sem a mobilon — csak a saját tesztje hívta.
   *  2. UGYANARRA A KÉRDÉSRE MÁR VAN ÉLŐ, HASZNÁLT ÚT: a „van-e szabad asztal" döntést a
   *     `GET /api/events/table-availability` végpont adja (`eventService.checkTableAvailability`,
   *     hívó: `components/Calendar/TableReservationDialog.tsx`), és a SZERVER SZÁMOLJA KI
   *     (`EventController.cs` → `isAvailable = availableTables >= requiredTables`), sőt magyar
   *     `message`-t is ad. Két, egymástól független válasz ugyanarra az üzleti kérdésre biztos
   *     félrecsúszás: elég egyszer módosítani a foglaltság-szabályt, és a kettő szétmegy.
   *  3. A `hasEnoughTables()` ezt a szerver-oldali döntést KLIENSEN ismételte meg — új
   *     absztrakció ugyanarra a döntésre, holnap már két helyen kellene javítani.
   *  4. A hozzá tartozó tesztek a SAJÁT mockjukat olvasták vissza (a fixture-t maguk gyártották),
   *     tehát a szerver szerződéséről semmit nem bizonyítottak — az „nincs `isAvailable` mező"
   *     őr is a teszt saját objektumán futott.
   *
   * A `GET /api/venues/{id}/availability` végpont a SZERVEREN megmarad (van rá backend
   * paraméter-őr teszt); ha egyszer kelleni fog, a MÉRT válasz-alakja ez volt:
   *   { venueId, totalTables, timeRange: { start, end }, occupiedTables, availableTables,
   *     occupancyPercentage, conflictingEvents: [ { id, name, start, end, tables } ] }
   *   — `isAvailable` és `venueName` NINCS benne, és a kontroller CSAK `startTime`/`endTime`
   *   paramétert fogad. De előtte tedd fel a kérdést, hogy nem a fenti,
   *   `events/table-availability` úton kellene-e menni.
   */
};
